import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

export const ToastContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Toast = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 300px;
  max-width: 400px;
  animation: ${slideIn} 0.3s ease-out;
  
  ${props => props.type === 'success' && `
    background: #F0FDF4;
    border: 1px solid #BBF7D0;
    color: #16A34A;
  `}
  
  ${props => props.type === 'error' && `
    background: #FEF2F2;
    border: 1px solid #FECACA;
    color: #DC2626;
  `}
  
  ${props => props.type === 'info' && `
    background: #EFF6FF;
    border: 1px solid #BFDBFE;
    color: #2563EB;
  `}
`;

export const ToastIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  ${props => props.type === 'success' && `
    color: #16A34A;
  `}
  
  ${props => props.type === 'error' && `
    color: #DC2626;
  `}
  
  ${props => props.type === 'info' && `
    color: #2563EB;
  `}
`;

export const ToastContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ToastMessage = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
`;

export const ToastCloseButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
  
  &:hover {
    opacity: 1;
  }
`;
